/* eslint-disable tailwindcss/no-custom-classname */
import { Writer as WriterType } from '@/types/summary'
import { useState } from 'react'
import { Writer } from '.'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

interface Props {
  review: string
  writer: WriterType
}
export const Review: React.FC<Props> = ({ review, writer }) => {
  const [show, setShow] = useState(false)
  const router = useRouter()
  useEffect(() => {
    setShow(false)
  }, [router])

  const onClick = () => {
    setShow(!show)
  }
  return (
    <div className="relative p-0 mt-[-1em]">
      <fieldset className="px-5 pb-[10px] mt-5 text-[17px] border border-[#e6e6e6] border-none sm:border-solid">
        <legend className="px-0 mb-5 w-full font-medium leading-4 text-center text-[#333]">
          <div
            className={`relative after:absolute after:top-[calc(50%-4px)] after:right-[20px] p-5 w-full after:w-3 after:h-3 text-[#293c6f] bg-[#f3f6fa] rounded border after:border-0 after:border-t-2 after:border-r-2 border-[#d9e2ed] after:border-[#fe8d42] border-solid after:border-solid cursor-pointer after:content-[''] ${
              show ? 'after:rotate-[-45deg]' : 'after:rotate-[135deg]'
            }`}
            onClick={onClick}
          >
            おすすめポイント
          </div>
        </legend>
        <div
          className={`ease-out duration-[400ms] ${
            show ? 'opacity-100 leading-8' : 'opacity-0 leading-[0px]'
          }`}
        >
          {review.split('<br />').map((r, i) => {
            return (
              <p
                key={i}
                className={`text-[17px] text-justify break-words indent-4 ${
                  show ? 'mb-6' : 'mb-0'
                }`}
                dangerouslySetInnerHTML={{ __html: r }}
              ></p>
            )
          })}
        </div>
        <Writer writer={writer} />
      </fieldset>
    </div>
  )
}
